module.exports = __webpack_public_path__ + "static/media/mobile-marca.5fe916ca.svg";